import React, { useState, useEffect, useRef } from 'react';
import { Outlet,useLocation } from "react-router-dom";
import { lang, page_url, getTextSize, img_url, openLink, gotoURL, gotoLink, check_brightness, chk_img } from './lang';
import { BsLine } from "react-icons/bs";
import { FaSearch } from "react-icons/fa";
import { RiMenuFill, RiCloseFill, RiArrowDropDownLine, RiArrowDropUpLine } from "react-icons/ri";
import { FaPhoneAlt, FaFacebookF, FaEnvelope, FaTwitter, FaYoutube, FaTiktok, FaAlignRight, FaChevronDown } from 'react-icons/fa';
import api from './api';
import layout from '../assets/css/module/layout.module.css';
import ThemeContext from '../context/ThemeContext';
import Menu from './Template/NavMenu';
import enlogo from '../assets/b_en.jpg';
import thlogo from '../assets/b_thai.jpg';

export default function HomeLayout() {
    const [search_type, setSearchType] = useState('food_name');
    const [keyword, setKeyword] = useState('');
    const [open_menu, setOpenMenu] = useState(false);
    const [show_lang, setShowLang] = useState(false);
    const [show_lang2, setShowLang2] = useState(false);
    const [language, setLang] = useState("th");
    const [selected_menu, setSelectMenu] = useState([1]);
    const [menu_level, setMenuLevel] = useState(0);
    const [page, setPage] = useState("About Us");
    const [init, setInit] = useState({src:undefined});
    const [footer_th, setFooterTh] = useState("");
    const [footer_en, setFooterEn] = useState("");
    const [bg_color, setBGColor] = useState("#fff");
    const [bg_header_th, setBGHeaderTh] = useState("");
    const [bg_header_en, setBGHeaderEn] = useState("");
    const [bg_footer_th, setBGFooterTh] = useState("");
    const [bg_footer_en, setBGFooterEn] = useState("");
    const [department_th, setDepartmentTh] = useState("");
    const [link, setLink] = useState("");
    const [article, setArticle] = useState([]);
    const [config, setConfig] = useState({});
    const header_ref = useRef(null);
    const body_ref = useRef(null);
    const lang_ref = useRef(null);
    const lang_ref2 = useRef(null);
    const location = useLocation();

    const [visitorCount, setVisitorCount] = useState([]);

    useEffect(()=>{
        if(lang==="en"){
            document.title = init.name_en;
        }else{
            document.title = init.name_th;
        }
    },[lang]);

    const fetchMenus = async () =>{
        try {
            const init_response = await api.get('/setting');
            setInit(init_response.data.results);
            let result = init_response.data.results;
            setFooterTh(result.footer_th);
            setFooterEn(result.footer_en);
            const home_config = JSON.parse(result.config);
            setBGColor(home_config.bg_color);
            setBGHeaderTh(home_config.bg_header_th);
            setBGHeaderEn(home_config.bg_header_en);
            setBGFooterTh(home_config.bg_footer_th);
            setBGFooterEn(home_config.bg_footer_en);
            document.title = result.name_th;
            document.body.style.backgroundColor = home_config.bg_color;
            // document.body.style.backgroundImage = "url('/images/th/ntic-main-background.jpg')";
            // console.log(result);

            const response = await api.get('/article/1');
            setArticle(response.data.results);
            // console.log(response.data.results);
            const config = JSON.parse(response.data.results.detail);
            setConfig(config);
        } catch (err) {
            if(err.response){
                //Not in 202 response range
                console.log(err.response.data);
                console.log(err.response.headers);
                console.log(err.response.status);
            } else {
                console.log(`Error: ${err.message}`);
            }
        }
    }

    const fetchVisitor = async () => {
      try {
        let visitor = [];
      
        // const response = await api.get('/visitors');
        // let result = response.data;
        // visitor.push({
        //   total:result.today,
        //   title_th:"วันนี้",
        //   title_en:"Today"
        // }); 
        visitor.push({
        //   total:result.yesterday,
          total:1,
          title_th:"วันนี้",
          title_en:"Today"
        }); 
        visitor.push({
        //   total:result.month,
          total:10,
          title_th:"เดือนนี้",
          title_en:"This Month"
        }); 
        // visitor.push({
        // //   total:result.year,
        //   total:10,
        //   title_th:"ปีนี้",
        //   title_en:"This Year"
        // });
        visitor.push({
          //   total:result.all,
          total:10,
          title_th:"สถิติทั้งหมด",
          title_en:"All"
        }); 
        setVisitorCount(visitor);
        localStorage.setItem("visitor",JSON.stringify(visitor));
        localStorage.setItem("last_visited",new Date().toLocaleDateString());
        
      } catch (err) {
          if(err.response){
              //Not in 202 response range
              console.log(err.response.data);
              console.log(err.response.headers);
              console.log(err.response.status);
          } else {
              console.log(`Error: ${err.message}`);
          }
      }
    }

    useEffect(()=>{
          fetchMenus();
          setLang(prev => localStorage.getItem("lang"));

          let visitor=localStorage.getItem("visitor");
          // console.log(visitor);
          if(!visitor){
              fetchVisitor();
          }else{
            var todayDate = new Date().toLocaleDateString();
            let lastVisit=localStorage.getItem("last_visited");
            if(lastVisit!==todayDate){
              fetchVisitor();
            }else{
              
              setVisitorCount(JSON.parse(visitor));
            }
          }
    },[]);


    const handleSearch = (e) => {
        e.preventDefault();
        // console.log(search_type);
        window.location = page_url+"search/"+search_type+"?keyword="+keyword;
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    }

    const setLanguage = (lang) => {
        setLang(prev => lang);
        localStorage.setItem("lang", lang);
    }


    const handleClickOutside = (event) => {
        if (lang_ref.current && !lang_ref.current.contains(event.target)) {
            setShowLang(false);
        }
    }

    useEffect(()=>{
        if(show_lang===true){
          document.addEventListener("mousedown", handleClickOutside);
        }else{
          document.removeEventListener("mousedown", handleClickOutside);
        }
    },[show_lang]);

    const toggleLanguage2 = (e) => {
        e.preventDefault();
        setShowLang2(current=>!current);
    }

    const handleClickOutside2 = (event) => {
        if (lang_ref2.current && !lang_ref2.current.contains(event.target)) {
            setShowLang2(false);
        }
    }

    useEffect(()=>{
          if(show_lang===true){
            document.addEventListener("mousedown", handleClickOutside2);
          }else{
            document.removeEventListener("mousedown", handleClickOutside2);
          }
    },[show_lang2]);
      
    const onSearchTypeChanged = (event) => {
        event.preventDefault();
        setSearchType(event.target.value);
    }
    
    return (
    <ThemeContext.Provider
      value={{ language, page, init }}
    >   
    <div className={layout["page-container"]} style={{backgroundImage:'url('+img_url+lang(config.th_cover_img,config.en_cover_img)+')'}}>
        <header ref={body_ref} className={layout["header"]}>
            <div className={layout["tools-box"]}>
                <div className={layout["search-box"]}>
                    <b>{lang('ค้นหา',"Search")}</b>
                    <form>
                        <fieldset>
                            <div className="input-group">
                                <input type="radio" name="search_type" id="search_type" value=  {"food_name"} checked={search_type === "food_name"} onChange={e=>onSearchTypeChanged(e)} /><p>{lang('ชื่ออาหาร','Food name')}</p>
                            </div>
                            <div className="input-group">
                                <input type="radio" name="search_type" id="search_type" value={"ingredient"} checked={search_type === "ingredient"} onChange={e=>onSearchTypeChanged(e)} /><p>{lang('ส่วนผสม','Ingredient')}</p>
                            </div>
                            <div className="input-group">
                                <input type="radio" name="search_type" id="search_type" value={"local_vegetable"} checked={search_type === "local_vegetable"} onChange={e=>onSearchTypeChanged(e)} /><p>{lang('ผักพื้นบ้าน','Local Vegetable')}</p>
                            </div>
                        </fieldset>
                        <fieldset className={layout["search-tool"]}>
                            <input type="text" name="keyword" id="keyword" value={keyword} onChange={e=>setKeyword(e.target.value)} />
                            <button type="button" onClick={e=>handleSearch(e)}><FaSearch /></button>
                            {/* <input type="button" value={lang("ค้นหา","Search")} onClick={e=>handleSearch(e)} /> */}
                        </fieldset>
                    </form>
                </div>
                <div className={layout["language-box"]}>
                    <ul>
                        <li>Tha <img src={thlogo} alt={lang("ภาษาไทย","Thai Version")} onClick={e=>setLanguage("th")} />|</li>
                        <li>Eng <img src={enlogo} alt={lang("ภาษาอังกฤษ","English Version")} onClick={e=>setLanguage("en")} /></li>
                    </ul>
                </div>
            </div>
        </header>
        <main className={getTextSize()}>
            <Outlet />
        </main>
        {(init)?
        <footer className={layout.footer} style={{backgroundImage:'url('+img_url+bg_footer_th+')'}}>
            <div className={layout["footer-header"]}>
            </div>
            <div className={layout["footer-detail"]}dangerouslySetInnerHTML={{ __html:lang(footer_th,footer_en)}}>
            </div>                 
        </footer>
        :''}
    </div>
    </ThemeContext.Provider>
  )
}
